/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MatchingOption,
    MatchingOptionFromJSON,
    MatchingOptionFromJSONTyped,
    MatchingOptionToJSON,
} from './MatchingOption';
import {
    SearchScope,
    SearchScopeFromJSON,
    SearchScopeFromJSONTyped,
    SearchScopeToJSON,
} from './SearchScope';

/**
 * プレスリリースを公開日順で取得するAPIのリクエスト
 * @export
 * @interface SearchPublishedDateOrderPressReleaseRequest
 */
export interface SearchPublishedDateOrderPressReleaseRequest {
    /**
     * 検索キーワード
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    searchKeyword?: string;
    /**
     * ビジネスカテゴリlv1のIDリスト
     * @type {Array<string>}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    busiCateLv1Ids?: Array<string>;
    /**
     * 企業カテゴリのIDリスト
     * @type {Array<string>}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    companyCateIds?: Array<string>;
    /**
     * エリアのIDリスト
     * @type {Array<number>}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    regionIds?: Array<number>;
    /**
     * 
     * @type {SearchScope}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    searchScope?: SearchScope;
    /**
     * 
     * @type {MatchingOption}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    matchingOption?: MatchingOption;
    /**
     * 取得開始日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    startDate?: string;
    /**
     * 取得終了日時。フォーマット：'Y-m-d H:i:s'
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    endDate?: string;
    /**
     * 次のデータを取得する開始点となる識別子. {unix_timestamp}_{company_id}_{release_id}という形式
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    cursor?: string;
    /**
     * 取得するプレスリリース数
     * @type {number}
     * @memberof SearchPublishedDateOrderPressReleaseRequest
     */
    limit?: number;
}

export function SearchPublishedDateOrderPressReleaseRequestFromJSON(json: any): SearchPublishedDateOrderPressReleaseRequest {
    return SearchPublishedDateOrderPressReleaseRequestFromJSONTyped(json, false);
}

export function SearchPublishedDateOrderPressReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPublishedDateOrderPressReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchKeyword': !exists(json, 'search_keyword') ? undefined : json['search_keyword'],
        'busiCateLv1Ids': !exists(json, 'busi_cate_lv1_ids') ? undefined : json['busi_cate_lv1_ids'],
        'companyCateIds': !exists(json, 'company_cate_ids') ? undefined : json['company_cate_ids'],
        'regionIds': !exists(json, 'region_ids') ? undefined : json['region_ids'],
        'searchScope': !exists(json, 'search_scope') ? undefined : SearchScopeFromJSON(json['search_scope']),
        'matchingOption': !exists(json, 'matching_option') ? undefined : MatchingOptionFromJSON(json['matching_option']),
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SearchPublishedDateOrderPressReleaseRequestToJSON(value?: SearchPublishedDateOrderPressReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'search_keyword': value.searchKeyword,
        'busi_cate_lv1_ids': value.busiCateLv1Ids,
        'company_cate_ids': value.companyCateIds,
        'region_ids': value.regionIds,
        'search_scope': SearchScopeToJSON(value.searchScope),
        'matching_option': MatchingOptionToJSON(value.matchingOption),
        'start_date': value.startDate,
        'end_date': value.endDate,
        'cursor': value.cursor,
        'limit': value.limit,
    };
}

